import { useRef, useState } from 'react';
import { useRegistrationService } from '../service/registrationService';
import { Device } from '../types/device';

export function useDevicesState() {
  const [devices, setDevices] = useState<Device[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const loading = useRef<boolean>(false);
  const { getUnregisteredDevices } = useRegistrationService();

  async function fetchDevices() {
    if (!loading.current) {
      loading.current = true;
      setIsLoading(true);
      try {
        let response: Device[] = await getUnregisteredDevices();
        if (Array.isArray(response) && response.length !== 0) {
          const sortedResponse: Device[] = sortDevices(response);
          setDevices(sortedResponse);
          return sortedResponse;
        } else {
          setDevices(response);
          return response;
        }
      } catch (error) {
        console.error('Failed to fetch devices', error);
      } finally {
        loading.current = false;
        setIsLoading(false);
      }
    }
  }

  async function removeDevice(device: Device) {
    if (devices) {
      setDevices(devices.filter((d) => d.id !== device.id));
    }
  }

  function resetDevices() {
    setDevices(null);
    setIsLoading(false);
    loading.current = false;
  }

  function sortDevices(devices: Device[]): Device[] {
    return devices.sort((a, b) => {
      if (!a.deliverDate) return 1;
      if (!b.deliverDate) return -1;
      return a.deliverDate.localeCompare(b.deliverDate);
    });
  }

  return {
    fetchDevices,
    devices,
    isLoading,
    removeDevice,
    resetDevices
  };
}
